import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class PumpkinLighting extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, pumpkinID) {
    super(scene);

    this.pumpkinID = pumpkinID;
    this.pumpkinDarknessTween = null;

    this.curFlicker = 1;

    this.candleLit = false;

    this.flickerWaiter = 1;

    this.pumpkinDarkness = ABCyaPhaser.Images.addImage(0,0,`pumpkin_inside${this.pumpkinID}`, this).setOrigin(0)
      .setTintFill(0x000000)
      .setAlpha(0);

    this.workingWidth = Math.floor(this.pumpkinDarkness.width);
    this.workingHeight = Math.floor(this.pumpkinDarkness.height);

    this.flicker = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._LightGlow, this).setOrigin(0);
    this.flicker.x = this.workingWidth / 2 - Math.floor(this.flicker.width) / 2;
    this.flicker.y = this.workingHeight / 2 - Math.floor(this.flicker.height) / 2 + 10;

    this.candle = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Candle, this).setOrigin(0);
    this.candle.x = this.workingWidth / 2 - this.candle.width / 2 + 13;
    this.candle.y = this.workingHeight - this.candle.height - 40;

    this.flame = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Flame_1, this).setOrigin(0);
    this.flame.x = this.candle.x + (this.candle.width / 2) - (this.flame.width / 2) - 10;
    this.flame.y = this.candle.y - 54;

    this.bringToTop(this.pumpkinDarkness);

    this.flicker.setVisible(false);
    this.candle.setVisible(false);
    this.flame.setVisible(false);
  }

  reset (pumpkinID) {
    this.pumpkinID = pumpkinID;
    this.pumpkinDarkness.setFrame(`pumpkin_inside${this.pumpkinID}`).setOrigin(0);

    this.pumpkinDarkness.alpha = 0;

    this.workingWidth = this.pumpkinDarkness.width;
    this.workingHeight = this.pumpkinDarkness.height;
    this.flicker.x = this.workingWidth / 2 - Math.floor(this.flicker.width) / 2;
    this.flicker.y = this.workingHeight / 2 - Math.floor(this.flicker.height) / 2 + 10;
    this.candle.x = this.workingWidth / 2 - this.candle.width / 2 + 13;
    this.candle.y = this.workingHeight - this.candle.height - 40;
    this.flame.x = this.candle.x + (this.candle.width / 2) - (this.flame.width / 2) - 10;
    this.flame.y = this.candle.y - 54;
  }

  resetDark () {
    this.pumpkinDarkness.alpha = 0;
    this.scene.tweens.killTweensOf(this.pumpkinDarkness);
    this.pumpkinDarknessTween = ABCyaPhaser.Tweens.addTween(this.pumpkinDarkness, 400, { alpha: 0.8 }, Phaser.Math.Easing.Linear, () => this.noTween());

    this.flicker.setVisible(false);
    this.candle.setVisible(false);
    this.flame.setVisible(false);
  }

  toggleCandle () {
    this.candleLit = !this.candleLit;
    if (this.candleLit) {
      this.flickerWaiter = 0;
      this.flicker.setVisible(true);
      this.candle.setVisible(true);
      this.flame.setVisible(true);
      this.scene.tweens.killTweensOf(this.pumpkinDarkness);
      this.pumpkinDarknessTween = ABCyaPhaser.Tweens.addTween(this.pumpkinDarkness, 120, { alpha: 0 }, Phaser.Math.Easing.Linear, () => this.noTween());
    }
    else {
      this.flicker.setVisible(false);
      this.flame.setVisible(false);
      this.scene.tweens.killTweensOf(this.pumpkinDarkness);
      this.pumpkinDarknessTween = ABCyaPhaser.Tweens.addTween(this.pumpkinDarkness, 120, { alpha: 0.8 }, Phaser.Math.Easing.Linear, () => this.noTween());
    }
    return this.candleLit;
  }

  hide () {
    this.candleLit = false;
    this.flicker.setVisible(false);
    this.candle.setVisible(false);
    this.flame.setVisible(false);
    this.scene.tweens.killTweensOf(this.pumpkinDarkness);
    this.pumpkinDarkness.alpha = Phaser.Math.Between(1,3) / 10;
    this.pumpkinDarknessTween = ABCyaPhaser.Tweens.addTween(this.pumpkinDarkness, 400, { alpha: 0 }, Phaser.Math.Easing.Linear, () => this.noTween());
  }

  noTween () {
    this.pumpkinDarknessTween = null;
  }

  tick (dt) {
    if (!this.candleLit) return;
    if (this.flickerWaiter <= 0) {
      if (this.curFlicker > 2) this.curFlicker = 1;
      this.flame.setFrame(`Flame_${this.curFlicker}`).setOrigin(0);
      if (this.curFlicker > 1 && Phaser.Math.Between(1,100) > 50) {
        this.flicker.alpha = Phaser.Math.Between(6,8) / 10;
        if (this.pumpkinDarknessTween === null && Phaser.Math.Between(1,100) > 79) {
          this.pumpkinDarkness.alpha = Phaser.Math.Between(1,3) / 10;
        }
      }
      else {
        this.flicker.alpha = 1;
        if (!this.pumpkinDarknessTween) this.pumpkinDarkness.alpha = 0;
      }
      this.curFlicker++;
      this.flickerWaiter = 0.1;
    }
    else {
      this.flickerWaiter -= dt;
    }
  }
}